import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

import { SANITIZE_PROFILE_DEFAULT } from './default';

/**
 * The WhatsApp channel can support rich messages with formatting, links, and
 * lists, but no inline images or headings (WA app doesn't support them).
 */
export const SANITIZE_PROFILE_WHATSAPP: SanitizationOption = {
  allowedTags: [
    'b',
    'i',
    'strong',
    'a',
    'em',
    'ul',
    'ol',
    'li',
    'br',
    'code',
    'div',
    'p',
    'blockquote',
    'placeholderp',
    'span',
    'del',
  ],
  allowedAttributes: {
    '*': ['dir', 'style', 'aria-*'],
    a: ['href', 'target', 'rel'],
  },
  allowedClasses: {
    em: ['highlight'],
  },
  transformTags: {
    p: 'placeholderp',
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
};
